module.exports = __webpack_public_path__ + "img/light.c7394214.svg";